import { render } from "./FrancaisAdvancedMaterialDetails.vue?vue&type=template&id=3937e2b5&scoped=true"
import script from "./FrancaisAdvancedMaterialDetails.vue?vue&type=script&lang=js"
export * from "./FrancaisAdvancedMaterialDetails.vue?vue&type=script&lang=js"

import "./FrancaisAdvancedMaterialDetails.vue?vue&type=style&index=0&id=3937e2b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3937e2b5"]])

export default __exports__